import { createContext, useContext, useMemo, useState } from 'react';

export const DEFAULT_SEASON = 2026;
export const SEASONS = [2026, 2025];

const CURRENT_WEEK_BY_SEASON = {
  2025: '17',
  2026: '05',
};

const SeasonContext = createContext(null);

export function SeasonProvider({ children }) {
  const [season, setSeasonState] = useState(DEFAULT_SEASON);

  const setSeason = (next) => {
    const value = Number(next);
    if (SEASONS.includes(value)) setSeasonState(value);
  };

  const value = useMemo(
    () => ({
      season,
      setSeason,
      currentWeek: CURRENT_WEEK_BY_SEASON[season],
      canMutate: season === DEFAULT_SEASON,
    }),
    [season]
  );

  return <SeasonContext.Provider value={value}>{children}</SeasonContext.Provider>;
}

export function useSeason() {
  const ctx = useContext(SeasonContext);
  if (!ctx) {
    throw new Error('useSeason must be used within SeasonProvider');
  }
  return ctx;
}
